import React from 'react';
import { styled } from '@mui/material';
import { Colors, Text } from 'library';
import { Link } from 'react-router-dom';

export function ProgressItem({
    text,
    to,
    backgroundColor,
    icon,
    onClick,
}: {
    text: string;
    to?: string;
    backgroundColor?: string;
    icon: React.ReactElement;
    onClick?: () => void;
}) {
    function getRowType(children: React.ReactElement) {
        if (to) {
            return (
                <LinkRow to={to} backgroundColor={backgroundColor}>
                    {children}
                </LinkRow>
            );
        } else if (onClick) {
            return (
                <ActionRow onClick={onClick} backgroundColor={backgroundColor}>
                    {children}
                </ActionRow>
            );
        }

        return <NonAction backgroundColor={backgroundColor}>{children}</NonAction>;
    }

    return getRowType(
        <>
            <Body>
                <Text variant="h2" bold>
                    {text}
                </Text>
            </Body>
            {icon}
        </>,
    );
}

const LinkRow = styled(Link)(({ backgroundColor }: { backgroundColor?: string }) => ({
    alignItems: 'center',
    backgroundColor: backgroundColor || Colors.fill,
    borderRadius: 10,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 5,
    marginTop: 5,
    padding: '5px 10px',
    '&:hover': {
        backgroundColor: Colors.fill,
    },
}));

const NonAction = styled('div')(({ backgroundColor }: { backgroundColor?: string }) => ({
    alignItems: 'center',
    backgroundColor: backgroundColor || Colors.fill,
    borderRadius: 10,
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 5,
    marginTop: 5,
    padding: '5px 10px',
}));

const ActionRow = styled('div')(({ backgroundColor }: { backgroundColor?: string }) => ({
    alignItems: 'center',
    backgroundColor: backgroundColor || Colors.fill,
    borderRadius: 10,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: 5,
    marginTop: 5,
    padding: '5px 10px',
    '&:hover': {
        backgroundColor: Colors.fill,
        textDecoration: 'underline',
    },
}));

const Body = styled('div')({
    width: '80%',
});
